import * as React from 'react';

import { ScrollArea, ScrollBar } from './components/ui/scroll-area.js';

export function DimeScrollArea({ ...props }: Readonly<React.ComponentProps<typeof ScrollArea>>) {
  return <ScrollArea {...props} />;
}

export function DimeScrollBar({ ...props }: Readonly<React.ComponentProps<typeof ScrollBar>>) {
  return <ScrollBar {...props} />;
}
